module.exports = __webpack_public_path__ + "static/media/PrescriptionRed.33dacca2.png";